import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var IosShare = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 8h-5v2h3v11H6V10h3V8H4v15h16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 16h2V5h3l-4-4-4 4h3z"
  }));
});
IosShare.displayName = 'IosShare';
export var IosShareDimensions = {
  height: 24,
  width: 24
};